var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 86.176c.08 0 .158-.005.238-.005h-.476c.08 0 .158.005.238.005m12.615-31.554H37.383c-8.53.78-15.561 6.712-17.971 14.657 6.376 10.081 17.586 16.809 30.351 16.892h.476c12.765-.083 23.974-6.811 30.35-16.892-2.411-7.945-9.444-13.878-17.974-14.657",
    fill: "#ffffff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 33.544,
    r: 17.955,
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 5C25.188 5 5 25.187 5 50s20.188 45 45 45c24.814 0 45-20.188 45-45S74.814 5 50 5m0 84.706C28.072 89.706 10.294 71.93 10.294 50S28.072 10.293 50 10.293c21.93 0 39.706 17.776 39.706 39.707 0 21.93-17.776 39.706-39.706 39.706",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewProfile);
export default __webpack_public_path__ + "static/media/new-profile.c1708e9702378950adef6d3bcdceab6b.svg";
export { ForwardRef as ReactComponent };